import React from "react";
import { Button, Checkbox, FormControlLabel, Paper } from "@material-ui/core";

interface IProps {
  source: string;
  preview: boolean;
  onContinue?: () => void;
}
export default function DocViewer(props: IProps) {
  const { source, preview, onContinue } = props;
  const [acknowledged, setAcknowledged] = React.useState(false);
  const [key, setKey] = React.useState(new Date().getTime());
  const [timer, setTimer] = React.useState();

  React.useEffect(() => {
    let t: any;
    if (source) {
      t = setTimeout(() => {
        console.log("Doc Viewer not loaded. Refreshing.");
        setKey(new Date().getTime());
      }, 1500);
      setTimer(t);
    }
    return () => {
      if (t) clearTimeout(t);
    };
  }, [source]);

  function onLoad() {
    if (timer) clearTimeout(timer);
  }

  function onError() {
    console.log("ERROR");
  }

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        flex: 1
      }}
    >
      <iframe
        key={key}
        src={`https://docs.google.com/gview?url=${encodeURIComponent(
          source
        )}&embedded=true`}
        onLoad={onLoad}
        style={{ flex: 1 }}
        title="Empathi Document Viewer"
        onError={onError}
      />
      {!preview ? (
        <Paper
          className="buttons-container right"
          elevation={4}
          style={{
            background: "#f5f5f5",
            padding: "16px 40px",
            borderRadius: 0
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={acknowledged}
                onChange={() => {
                  setAcknowledged(!acknowledged);
                }}
                color="primary"
              />
            }
            label="I hereby acknowledge that I have read, understand and agree to
            the terms of this document."
          />
          <div style={{ flex: 1 }} />
          <Button
            variant="contained"
            color="primary"
            disabled={!acknowledged}
            onClick={() => {
              onContinue?.();
              setAcknowledged(false);
            }}
            style={{ margin: 0 }}
          >
            Continue
          </Button>
        </Paper>
      ) : null}
    </div>
  );
}
